
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 業種管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" class="mr-2" color="dark" @click="recordModal = true">編集</CButton>
                  <CButton size="sm" color="danger"  @click="deleteModal = true">削除</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="8" class="offset-md-2">
                <dl v-for="(k, v) in record" class="row" :key="k">
                  <dt class="col-sm-3">{{labelDic[v]}}</dt>
                  <dd class="col-sm-9">
                    {{formatData(v,k)}}
                  </dd>
                </dl>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      title="編集"
      color="dark"
      :show.sync="recordModal"
    >
       <CRow>
         <CCol sm="12">
           <CInput
             label="業種名"
             placeholder="例) 水産"
             v-model="record.name"
           />
         </CCol>
       </CRow>
       <CRow>
         <CCol sm="12">
           <label>業種に関する説明</label>
           <CTextarea
             placeholder="例)漁師等"
             rows="5"
             v-model="record.description"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">試験での実施言語</label>
           <CInput placeholder="実施言語" v-model="record.language"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">実施方法</label>
           <CInput placeholder="実施方法" v-model="record.method"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">実施方式</label>
           <CInput placeholder="実施方式" v-model="record.way"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験区分</label>
           <CTextarea
             placeholder="例)試験の範囲を入力してください"
             rows="5"
             v-model="record.section"
           />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験結果の通知方法</label>
           <CInput placeholder="例) ホームページにて結果を通知します" v-model="record.notify"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">試験結果の合格基準</label>
           <CInput placeholder="試験結果の通知方法" v-model="record.border"/>
         </CCol>
       </CRow>


       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem()">登録</CButton>
       </template>
    </CModal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      record: {},
      labelDic: {
          "id": "ID",
          "name": "業種名",
          "description": "業種の簡単な説明",
          "language": "試験の実施言語",
          "method": "試験の実施方法",
          "way": "試験の実施方式",
          "section": "試験区分",
          "notify": "試験結果の通知",
          "border": "試験の合格基準",
          "created_at": "作成日",
          "updated_at": "更新日"
      }
    }
  },
  methods: {
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    updateItem: function() {
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/industries/" + this.record.id, {"industry": this.record})
        .then(() => {
          this.recordModal = false
        }).catch(error => {
          console.log(error)
        })
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/industries/" + this.record.id)
        .then(() => {
          this.deleteModal = false
          this.$router.push('/industries')

        }).catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries/" + this.$route.params.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.record = response.data
      }).catch(error => {
          console.log(error)
      })
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
